import { useCallback, useContext } from 'react'
import { Feature, MeteringModule, Permissions } from 'src/api/api.generated'
import { hicContext } from 'src/app/hooks/context/context'
import { useEnv } from './environment-hooks'

export const useGrant = () => {
  const { context } = useContext(hicContext)
  const { isDevEnv } = useEnv()

  /**
   * Check if user have the authorization level required
   */
  const isGranted = useCallback(
    (authLevelRequired: { modules?: MeteringModule[]; features?: Feature[]; permissions?: Permissions[] }) => {
      if (!context.loading) {
        const { modules, features, permissions } = authLevelRequired

        const moduleGrant = modules ? modules.some((x) => context.permissions?.modules?.includes(x)) : true
        const permissionGrant = permissions ? permissions.some((x) => context?.permissions?.userRole?.permissions?.includes(x)) : true
        const featureGrant = features ? features.some((x) => context?.permissions?.features?.includes(x)) : true

        return moduleGrant && permissionGrant && featureGrant
      }
      return false
    },
    [context.loading],
  )

  /**
   * Check if user is in one of the roles required
   */
  const isInRole = useCallback(
    (roles: string[]) => {
      // +++++ THIS IS A SECURITY BYPASS ONLY FOR DEVELOPMENT ENVIRONMENT +++++
      if (isDevEnv) return true

      if (!context.loading) return roles.some((x) => context.permissions?.userRole?.code === x)
      return false
    },
    [context.loading],
  )

  return { isGranted, isInRole }
}
